import { render, staticRenderFns } from "./ContactCard.vue?vue&type=template&id=3ff15f16&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"
import style0 from "./ContactCard.vue?vue&type=style&index=0&id=3ff15f16&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff15f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff15f16')) {
      api.createRecord('3ff15f16', component.options)
    } else {
      api.reload('3ff15f16', component.options)
    }
    module.hot.accept("./ContactCard.vue?vue&type=template&id=3ff15f16&scoped=true", function () {
      api.rerender('3ff15f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/ContactCard.vue"
export default component.exports